import React from 'react';
import { ORDERING_MODES } from '@sonifi/wb-admin/constants/wbAdminConstants';

const InRoomDinning = ({ getValues, setValue }) => {
  const handleOrderingModeChange = (orderingMode) => {
    setValue('products.ird.settings.available_ordering_modes', {
      ...ORDERING_MODES,
      [orderingMode]: true,
    });
  };

  return (
    <div className="col-md-8">
      <div className="row col-md-offset-1">
        <label>Ordering Type:</label>
        <br />
        <div className="row col-md-offset-1">
          <input
            id="email_ordering_radio"
            type="radio"
            value="email"
            name="ordering_modes"
            required
            checked={getValues(
              'products.ird.settings.available_ordering_modes.email',
            )}
            onChange={(e) => handleOrderingModeChange(e.target.value)}
          />
          <label htmlFor="email_ordering_radio" className="col-md-column-18">
            Email
          </label>
          <br />
          <input
            id="read_only_radio"
            type="radio"
            value="read_only"
            name="ordering_modes"
            required
            checked={getValues(
              'products.ird.settings.available_ordering_modes.read_only',
            )}
            onChange={(e) => handleOrderingModeChange(e.target.value)}
          />
          <label htmlFor="read_only_radio" className="col-md-column-18">
            Read-only
          </label>
        </div>
      </div>
      <div className="row col-md-offset-1">
        <em className="help-block">
          Reminder: The above configuration may affect the Settings for this
          service. Make sure to review the Settings tab before publishing.
        </em>
      </div>
    </div>
  );
};

export default InRoomDinning;
